    import HttpService from "./HttpService";

let relatorioService = {

    findOwners: () => {
        return HttpService.backApi.get("/relatorio/owners");
    },

    findAvaliacoes: (ownerId) => {
        return HttpService.backApi.get(`/relatorio/avaliacoes/${ownerId}`);
    },

    findEscolasByAvaliacao: (avaliacaoId) => {
        return HttpService.backApi.get(`/relatorio/escolas/${avaliacaoId}`);
    },

    findTurmasByEscola: (idEscola, idAvaliacao) => {
        return HttpService.backApi.get(`/relatorio/turmas/${idEscola}/${idAvaliacao}`);
    },


    findTurmasByAvaliacao: (avaliacaoId) => {
        return HttpService.backApi.get(`/relatorio/rede/turmas/${avaliacaoId}`);
    },

    findAlunosByTurmaAndAvaliacao: (idAvaliacao, idTurma, idCaderno) => {
        return HttpService.backApi.get(`/relatorio/alunos/${idAvaliacao}/${idTurma}/${idCaderno}`);
    },

    getRedeData: (ownerId, avaliacaoId, ano) => {
        return HttpService.backApi.get(`/relatorio/rede/dados/${ownerId}/${avaliacaoId}/${ano}`);
    },

    getTurmaData: (ownerId, avaliacaoId, turmaId) => {
        return HttpService.backApi.post(`/relatorio/turmas/dados/${ownerId}/${avaliacaoId}/${turmaId}`);
    },

    getEscolaData: (ownerId, escolaId, avaliacaoId) => {
        return HttpService.backApi.post(`/relatorio/escolas/dados/${ownerId}/${escolaId}/${avaliacaoId}`);
    },

    getAlunosData: (alunosFilter) => {
        return HttpService.backApi.post('/relatorio/alunos/dados', alunosFilter)
    },

    getAlunosDataV2: (filter) => {
        return HttpService.backApi.post('/relatorio/v2/alunos', filter)
    }

};

export default relatorioService;
